import {createFeature, createReducer, on} from "@ngrx/store";
import {APP_CONSTANTS} from "../../app.constants";
import {AssetModel, FilterInterface, PaginationInfoInterface} from "../../interfaces";
import * as AssetsActions from "../actions/assets.actions";

const assetsFeatureKey = "Assets";

export interface State {
  assetItems: Array<AssetModel>;
  assetItemsPaginated: Array<AssetModel>;
  assetFilters: FilterInterface;
  assetPaginationInfo: PaginationInfoInterface;
}

export const initialState: State = {
  assetItems: [],
  assetItemsPaginated: [],
  assetFilters: {
    limit: APP_CONSTANTS.PAGINATION_PAGE_SIZE,
    offset: 0
  },
  assetPaginationInfo: {
    from: 0,
    to: 0,
    totalResults: 0,
    currentPage: 0,
    totalPages: 1
  }
};

export const assetsFeature = createFeature({
  name: assetsFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      AssetsActions.setAssets,
      (state: State, {assets}): State => ({
        ...state,
        assetItems: assets
      })
    ),
    on(
      AssetsActions.setPaginatedAssets,
      (state: State, {assets}): State => ({
        ...state,
        assetItemsPaginated: assets
      })
    ),
    on(
      AssetsActions.setAssetsPaginationInfo,
      (state: State, {paginationInfo}): State => ({...state, assetPaginationInfo: paginationInfo})
    ),
    on(
      AssetsActions.gotoAssetsPage,
      (state: State, {page}): State => ({
        ...state,
        assetFilters: {...state.assetFilters, offset: state.assetFilters.limit * (page - 1)},
        assetPaginationInfo: {...state.assetPaginationInfo, currentPage: page}
      })
    ),
    on(AssetsActions.applyAssetsFilters, (state: State, {filters}): State => {
      const newFilters = {...state.assetFilters};
      filters.forEach(({key, value}) => {
        newFilters[key as string] = value;
      });
      newFilters.offset = 0;
      return {...state, assetFilters: newFilters};
    }),
    on(AssetsActions.resetAssetsFilters, (state: State): State => ({...state, assetFilters: initialState.assetFilters}))
  )
});

export const {
  name,
  reducer,
  selectAssetsState,
  selectAssetItems,
  selectAssetItemsPaginated,
  selectAssetFilters,
  selectAssetPaginationInfo
} = assetsFeature;
